<template>
  <router-link
    v-if="visible"
    class="metabase-button"
    :to="{
      name: 'MetabaseApplication'
    }"
  >
    <icon glyph="customer-intelligence" />
    Intelligence
  </router-link>
</template>

<script>
export default {
  name: 'TopToolbarMetabaseLink',

  computed: {
    visible() {
      return (
        this.$can('Metabase:ReadAccess') &&
        this.$store.state.app.user &&
        this.$store.state.app.user.metabase
      )
    }
  }
}
</script>

<style scoped>
.metabase-button {
  background: #1d87c8;
  cursor: pointer;
  border-left: 1px solid #176ca0;
  padding-left: 30px;
  padding-right: 30px;
  color: #ffffff;
  line-height: 64px;
  font-size: 14px;
}

.metabase-button:hover {
  background: #0775b6;
  color: #ffffff;
}

.metabase-button .icon {
  line-height: 64px;
  font-size: 24px;
  margin-right: 10px;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/common/components/navigation/TopToolbarMetabaseLink.vue